var React = require('react');

function ArrowNext (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.172 6.99992H0V8.99992H12.172L6.808 14.3639L8.222 15.7779L16 7.99992L8.222 0.221924L6.808 1.63592L12.172 6.99992Z","fill":"#D6E2DD"}));
}

ArrowNext.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ArrowNext;

ArrowNext.default = ArrowNext;
